import { useState } from "preact/hooks";

interface Source {
  filename: string;
  score: number;
}

function friendlySource(filename: string): string {
  // Uploaded files keep their original names; scraped .md files get humanized
  if (!filename.endsWith(".md") || !filename.includes("_")) return filename;
  const name = filename.replace(/\.md$/, "");
  const parts = name.split("_").filter(Boolean);
  if (parts.length <= 1) return filename;
  // Keep domain for context: "example.com / blog / pricing"
  const domain = parts[0].replace(/^www\./, "");
  const path = parts.slice(1).join(" / ").replace(/-/g, " ");
  return `${domain} / ${path}`;
}

export function SourceCitations({ sources }: { sources: Source[] }) {
  const [open, setOpen] = useState(false);

  if (!sources || sources.length === 0) return null;

  return (
    <div class="mt-1.5">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        class="inline-flex items-center gap-1 bg-transparent border-none py-0.5 cursor-pointer text-[11px] text-[var(--muted-foreground)] font-[inherit] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] rounded"
      >
        <svg class="size-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
        </svg>
        Sources ({sources.length})
        <svg
          class="size-2.5 transition-transform duration-150"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div class="mt-1 flex flex-col gap-0.5">
          {sources.map((s, i) => (
            <div
              key={i}
              class="flex items-center justify-between text-[11px] px-1.5 py-0.5 rounded bg-[var(--background)]"
            >
              <span class="overflow-hidden text-ellipsis whitespace-nowrap max-w-[200px] text-[var(--foreground)]">
                {friendlySource(s.filename)}
              </span>
              <span class="text-[var(--muted-foreground)] ml-2 shrink-0">
                {Math.round(s.score * 100)}%
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
